
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 512 411","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M487.2 107.2h-22.5V87.1h40.2c3.5 0 5.9-2.4 5.9-5.9V65.9c0-3.5-2.4-5.9-5.9-5.9H398.5c-3.5 0-5.9 2.4-5.9 5.9V80c0 3.5 2.4 5.9 5.9 5.9h39v21.3H415c-13 0-24.8 11.8-24.8 24.8v10.6h-33.1V125c0-3.5-2.4-5.9-5.9-5.9h-30.7l-11.8-70.9h-33.1V6.7c0-3.5-2.4-5.9-5.9-5.9H136c-2.4 0-5.9 2.4-5.9 5.9v41.4H97l-16.6 97h26c0 46.1 2.4 68.6 18.9 92.2H6c-3.5 0-5.9 2.4-5.9 5.9v156.1c0 3.5 2.4 5.9 5.9 5.9h85c3.5 0 5.9-2.4 5.9-5.9v-41.4h44.9v40.2c0 3.5 2.4 5.9 5.9 5.9H162c3.5 0 5.9-2.4 5.9-5.9V264.5h68.6v134.8c0 3.5 2.4 5.9 5.9 5.9h14.2c3.5 0 5.9-2.4 5.9-5.9V257.4l3.5-3.5h84c3.5 0 5.9-2.4 5.9-5.9v-17.7h34.3v10.6c0 14.2 11.8 24.8 24.8 24.8h71c14.2 0 24.8-11.8 24.8-24.8V134.4c1.2-15.3-10.6-27.2-23.6-27.2zM70.9 359.1v20.1H26V264.5h44.9zM157.3 28h92.2v20.1h-92.2zm-45 92.3l7.1-44.9H285l7.1 44.9zm29.6 211.6H97v-68.6h44.9zm102.9-93.4h-84c-24.8-26-27.2-36.7-27.2-92.2h139.5c0 54.4-2.3 65-28.3 92.2zm86.3-13h-43.8c10.6-20.1 11.8-41.4 11.8-80.4h32zm59.1-23.7h-33.1v-33.1h33.1zm94.6 35.5h-68.6v-104h68.6z"}})])
          )
        }
      }
    